import { ImageSuiteApps, TextSuiteApps } from "../Helper";
import { SuitesAppTypes, workflowAppResultsType } from "../store/one-query/workflowsSlice";
import { selectedSettingType, SettingItemObjType, videoModelType, VideoSuiteApps } from "./VideoSuite-Types";

export interface workflowItem {
  appType: string;
  appId?:string;
  suiteType: number;
  selectedFromDropdownItem?: string;
  selectedToDropdownItem?: string;
  inputType?: string;
  outputType?: string;
  sliderValue?: number;
  appOrder: number;
  data?: any;
  userInputText?:string|null;
  userInput?:File | string | null;
  videoSettings?:selectedSettingType;
}
export interface WorkflowSuiteApps {
  apps: SuitesAppTypes[];
  selectedItemData: workflowItem;
  selectedSuiteType?: number;
  returnLastSelectedApp: workflowItem;
  handleSetActiveItem: (app: SuitesAppTypes) => void;
}
export interface SelectAppDataProps {
  currentStep?: workflowItem;
  activeItemData?: any;
  sliderValue?: number;
  selectedFromDropdownItem?: string;
  isFirstStep: boolean;
  selectedToDropdownItem?: string;
  setSelectedFromDropdownItem?: (value: string) => void;
  setSelectedToDropdownItem?: (value: string) => void;
  setSliderValue?: (value: number) => void;
  videoSettings?:selectedSettingType;
  handleModelSettingChanges?:(appId:string,name:string,value: number | string | SettingItemObjType | videoModelType)=>void;
  readOnly: boolean;
  canShow:boolean;
  outputTypeOfLastApp?:string |null;
}
export interface SelectVideoAppDataProps {
  handleUserInputImageChange:(activeAppId:string,image:File | string |null)=>void;
  handleUserInputTextChange:(activeAppId:string,text:string |null)=>void;

}
export interface AppsVisibilityType {
  Translator: boolean;
  Humanizer: boolean;
  Summarizer: boolean;
  Paraphraser: boolean;
  "Prompt Generator": boolean;
  "Text to Image":boolean;
  "Logo Generator": boolean;
  "Icon Generator": boolean;
  "Illustration Generator": boolean;
  "Image Restore": boolean;
  "Text Extractor": boolean;
  "Background Remover": boolean;
  "Text to Video":boolean;
  "Image to Video":boolean
}
export interface InputSettingProps {
  header: string;
  inputText: string;
}
export interface OutputSettingProps {
  readOnly:boolean;
}
export interface AppTypes{
  id:string,
  appId:string,
  suiteType: number;
  appType: string;
  inputType: string;
  outputType: string;
  appOrder: number;
  payload?:string;
}
interface workflowRuns{
  id:string,
  workflowId:string
  createdAt:string,
  workflowAppResults:workflowAppResultsType[]
}
export interface workflowTypes {
  id: string;
  name: string;
  apps: AppTypes[];
  workflowRuns:workflowRuns[];
  workflowType: number;
  }

export interface WorkflowTemplatesType {
  title: string;
  order: number;
  workflows: workflowTypes[];
  }

export const GetAppType=(appName:string)=>{
    if (Object.values(TextSuiteApps).includes(appName)) {
      return "Text";
    } else if (Object.values(ImageSuiteApps).includes(appName)) {
      return "Image";
    } else if (Object.values(VideoSuiteApps).includes(appName)) {
      return "Video";
    }
  }

  export enum WorkflowAppsType {
  // Text Suites
  Translator = "Translator",
  Humanizer = "Humanizer",
  Summarizer = "Summarizer",
  Paraphraser = "Paraphraser",
  TitleGenerator = "Title Generator",
  AIDetector = "AI Detector",
  PromptGenerator = "Prompt Generator",

  // Image Suites
  TextToImage = "Text to Image",
  LogoGenerator = "Logo Generator",
  IconGenerator = "Icon Generator",
  IllustrationGenerator = "Illustration Generator",
  BackgroundRemover = "Background Remover",
  ImageRestore = "Image Restore",
  TextExtraction = "Text Extractor",
  TinyFigures = "Tiny Figures",
  MicroPeople = "Micro People",
  ImageToPrompt = "Image to Prompt",
  ImageToImage = "Image to Image",

  // Video Suites
  TextToVideo = "Text to Video",
  ImageToVideo = "Image to Video",
  CustomAvatar = "Custom Avatar",
}
